require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-use-arrow-functions-to-write-concise-anonymous-functions.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-use-arrow-functions-to-write-concise-anonymous-functions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-use-arrow-functions-to-write-concise-anonymous-functions!./.cache/json/javascript-algorithms-and-data-structures-es-6-use-arrow-functions-to-write-concise-anonymous-functions.json
// module id = 2381
// module chunks = 231608221292675